import React from 'react';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api } from '../../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../../SuperAdmin/Layout';
import Pagination from 'react-js-pagination';
import "./super_admin_role_master.css";


const SuperAdminRoleMaster = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [shops, setShops] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [ searchQuery,setSearchQuery] = useState('');
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [ isEdit,setIsEdit ] = useState(false);
  
  const [ isCreate,setCreate ] = useState(false);

  const [ loading, setLoading ] = useState(false);
  const [ postloading,setPostLoading ] = useState(false);
 
  // Show modal
 const [currentPage, setCurrentPage] = useState(1);
 const [itemsPerPage] = useState(10); // Number of items per page
 const [searchTerm, setSearchTerm] = useState('');
 
 // Filtering tables based on search term
 const filteredTables = (tables || []).filter((item) => {
    return (
      item.role_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.role_description.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });
  
 
 // Pagination logic
 const indexOfLastItem = currentPage * itemsPerPage;
 const indexOfFirstItem = indexOfLastItem - itemsPerPage;
 const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
 const totalItems = filteredTables.length;
 
 const handleSearchInput = (event) => {
   setSearchTerm(event.target.value);
   setCurrentPage(1); // Reset to the first page when search changes
 };
 
 const handlePageChange = (pageNumber) => {
   setCurrentPage(pageNumber);
 };
  const [EmployeeD, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    role_name: "", 
    role_description: "", 
    is_active: '',
    shop_id: '',

});
const [updateformData, setUpdateFormData] = useState({
  role_name: "", 
  role_description: null, 
  is_active: null,
  shop_id: null,
  id: "",
 
});

    useEffect(() => {
        fetchTables();
      }, []);


      const fetchTables = async (id) => {
        const token = localStorage.getItem('SAtoken');
        console.log(id)
        const shopId =localStorage.getItem('SAShopId');
        try {
           const shop = localStorage.getItem('SAShopId')
           const response = await axios.get(`${var_api}admin-role/get`,{
            headers:{
              Authorization:`${token}`
            }
           });
           console.log("response",response)
          const user =response.data;
          setTables(user);
          
        } catch (error) {
          console.log(error);
          setTables([])
        }
      };
      


//handle text field change
const handleInputChange = (event) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value
  });
};


  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  

      //post the form data
    const Submit = async (e) => {
      e.preventDefault();
      setPostLoading(true);

      try {
        const shopId=localStorage.getItem('SAShopId');
        const payload = {
          shop_id:shopId,
          role_name: formData.role_name,
          role_description: formData.role_description,
          is_active:  1 ,
        };
        const token=localStorage.getItem('SAtoken');

        const response = await axios.post(`${var_api}admin-role/post`, payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization:`${token}`
            }
        });
        const result = response.data;
        console.log("rrrr",result);
          setCreate(false);
          fetchTables();
          setPostLoading(false)
          Swal.fire({
            icon:"success",
            text:'Role Created Successfully',
            confirmButtonColor:"#007500"
          })

          setFormData({...formData,
            role_name: "", 
            role_description: "", 
            is_active: '',
            shop_id: '',
          })
          

        
      } catch (error) {
    if (error.response) {
      setPostLoading(false)
      console.error('Server responded with error status:', error.response.status);
        setPostLoading(false)
        Swal.fire({
          icon:"error",
          text: error.response.data.message,
          confirmButtonColor:"#007500"
        })
      
        
      }
    };
  };


    //reset the values
    const handleToReset = () => {
         // Reset the form fields individually
         setFormData({
          ...formData,
          e_name: " ", 
  e_email: "", 
  e_password:" ",
  e_phone:"",
  e_role:"",
  profile:null
      });
    }

    //Go to home page
    const handleButtonClick = () => {
      history.push('/AdminHome')
    }


   

      

     //delete method for remove UOM
   const handleDeleteEmployee = (id) => {
    setShow(true);
    setEmployeeD({id:id})
    }


    //delete the employeee
    const handleDelete = () => {
      const token=localStorage.getItem('SAtoken');
      axios
      .delete(`${var_api}admin-role/delete/${EmployeeD.id}`,{
        headers:{
          Authorization:`${token}`
        }
      })
      .then((response) => {
        if (response.status === 200) {
          fetchTables();
          setShow(false);
          Swal.fire("success"," Role Removed Successfully!","success")
          // Perform any other actions you need on success
        } else if (response.status === 404) {
          console.log('Table not found');
          Swal.fire("error","Employee not found!","error")
        }
      })
      .catch((error) => {
        console.error('Error executing the request:', error);
        Swal.fire("error","Failed to Remove Employee!","error")
        // Handle the error as needed
      });
    }


    //Function for open the update modal
    const handleUpdateEmployee = (data) =>{
      setIsEdit(true);
      console.log("data",data)
      setUpdateFormData({
        role_name: data.role_name, 
        role_description: data.role_description, 
        is_active: data.is_active,
        shop_id: data.shop_id,
        id: data.id,

    
      })
    }
    const handleCreateEmployee = () =>{
      setCreate(true);
    }
    //Function for update text field onchange
const handleInputUpdateChange = (e) => {
  const { name, value } = e.target;
  setUpdateFormData({ ...updateformData, [name]: value });
};


//Oncahnge function for update role
const handleRoleUpdateChange = (selectedOption) => {
  console.log("hjdahj",selectedOption.value)
  setUpdateFormData({ ...updateformData, e_role: selectedOption.value});
};

//onchange function for file 
const handleImageUpdateChange = (e) => {
  const file = e.target.files[0];
  console.log("file",file)
  setUpdateFormData({ ...updateformData, profile: file });
};


 // Function to handle update checkbox change
 const handleUpdateCheckboxChange = (index) => {
  const updatedShops = [...updateformData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };
  console.log("upd",updatedShops);

  setUpdateFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};


//update method for employee
//post method for updating the food
const update = async (e) => {
  e.preventDefault();
  const paymodeData = {
    role_name: updateformData.role_name, 
    role_description: updateformData.role_description, 
    is_active: updateformData.is_active,
    shop_id: updateformData.shop_id,
  };
  try {
    const token = localStorage.getItem("SAtoken"); // Replace with your token logic
    const response = await axios.put(
      `${var_api}admin-role/put/${updateformData.id}`, // Use the selected item's ID
      paymodeData,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (response.status === 200) {
      Swal.fire("success"," Role Updated Successfully!","success")

      setIsEdit(false); // Close the modal
      fetchTables(); // Refresh the data
      setUpdateFormData({});
    }
  } catch (error) {
    Swal.fire("Error", `${error.response.data.message}`, "error");

    console.error("Error updating PAYMODE:", error);
  }
};

 
  const handleToggle = (isChecked, item) => {
    const payload = {
      shop_id: item.shop_id,
      role_name: item.role_name,
      role_description: item.role_description,
      is_active: isChecked ? 1 : 0, // Convert boolean to 1 or 0
    };
  
    const token = localStorage.getItem('SAtoken');
    
    axios
      .put(`${var_api}admin-role/put/${item.id}`, payload, {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          Swal.fire("Success", "Status updated successfully!", "success");
          fetchTables();
        } else {
          Swal.fire("Error", "Failed to update category status!", "error");
        }
      })
      .catch((error) => {
        console.error("Error updating category status:", error);
        Swal.fire("Error", `${error.response?.data?.error || "Unexpected error occurred"}`, "error");
      });
  };
  const cancel = async (e) => {
    setCreate(false);
    setFormData({}); 

  };
    return(
      <>         <Layout>

       
            <div class="splitrm">
          
      <div style={{border:"none",padding:"20px",width:"100%",height:"auto",margin:"auto",borderRadius:"15px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px"}}>
      
      <div>
     
       <div class="row">
         <div class="col">
         <h4 className='ushesarm'>ROLE MASTER</h4>
         </div>
         <div class="col">
       <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"14px",float:"right",borderRadius:"10px", marginLeft:"10px"}}>Create Role</Button>{' '}
       <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
    style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
       </div>
       </div>
      <div className="table-container" style={{ height:"500px", overflowX: 'auto', overflowY: 'scroll' }}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"100%",margin:"auto"}}>
     <thead>
    <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"center"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"center"}} scope="col">Role Name</th>
      <th style={{textTransform:"capitalize",textAlign:"center"}} scope="col">Description</th>
      <th style={{textTransform:"capitalize",textAlign:"center"}} scope="col">Status</th>
      <th style={{textTransform:"capitalize",textAlign:"center"}} scope="col">Action</th>
    </tr>
  </thead>
  {loading ? (
        <div className="loader-containeru">
      	  <div className="spinneru"></div>
        </div>
  ) : 
  <tbody className="body-half-screen">
  {currentItems.length === 0 ? (
    <tr>
      <td colSpan="5" style={{ textAlign: "center", padding: "10px",color:'grey'}}>
        No Data Available
      </td>
    </tr>
  ) : (
    currentItems.map((item, index) => (
      <tr key={item.id} style={{ padding: "7px" }}>
        <td style={{ textTransform: "capitalize", textAlign: "center" }}>{index + 1}</td>
        <td style={{ textTransform: "capitalize", textAlign: "center" }}>{item.role_name}</td>
        <td style={{ textAlign: "center" }}>{item.role_description}</td>
        <td style={{ textAlign: "center" }}>
          <div className="form-check form-switch" style={{ display: "flex", justifyContent: "center" }}>
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={item.is_active === 1} // Checkbox is checked if is_active is 1
              onChange={(e) => handleToggle(e.target.checked, item)}
            />
          </div>
        </td>
        <td style={{ textAlign: "center" }}>
          <i className="bi bi-pencil-square" onClick={() => handleUpdateEmployee(item)} style={{ fontSize: "20px", color: "rgb(9, 97, 9)" }}></i>{' '}
          <i className="bi bi-trash" onClick={() => handleDeleteEmployee(item.id)} style={{ fontSize: "21px", color: "rgb(175, 2, 2)" }}></i>
        </td>
      </tr>
    ))
  )}
</tbody>

}
</table>
<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />
      </div>
      

</div>
        </div>
      
      </div>

      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header style={{padding:"3px", backgroundColor:"green"}}>
          <Modal.Title style={{ fontSize:"20px"}}></Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         {/* <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4> */}
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Role 
          <span style={{color:"red",textTransform:"uppercase"}}> </span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>

      <Modal
        show={isEdit}
        onHide={()=>setIsEdit(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Update Role </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={update}>
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Role Name</label>
              <input type="text" class="form-control" placeholder="Enter Role name" id="input1" value={updateformData.role_name}  name="role_name"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
            <div class="col">
              <label for="input2" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Description</label>
              <input type="text" class="form-control" placeholder="Enter Description" id="input2" name="role_description" value={updateformData.role_description} onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
          </div>
          <br/>
         <br/>
          <button className="btn btn-success" style={{float:"right",margin:"5px",borderRadius:"15px"}}>Update</button>
          </form>
          <button className="btn btn-danger" onClick={()=>setIsEdit(false)} style={{borderRadius:"15px",float:"right",marginTop:"-1px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 

      <Modal
        show={isCreate}
        onHide={()=>setCreate(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Create Role </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={Submit}>
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Role Name</label>
               <input type="text" class="form-control" id="floatingInput" placeholder="Enter Role name" name='role_name' value={formData.role_name} onChange={handleInputChange}  style={{borderRadius:"15px",height:"50px"}} required/>
               </div>
            <div class="col">
              <label for="input2" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Description</label>
              <input type="text" class="form-control" id="floatingInput" placeholder="Enter Description" name='role_description' value={formData.role_description} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} required/>
              </div>
          </div>
          <br/>
         <div class="text-center">
          {postloading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
           
          />
        ) : (
          <button className='btn btn-success' style={{borderRadius:"15px",float:"right",marginTop:"6px"}} disabled={postloading}>Create</button>
        )}
        </div>           </form>
          <button className="btn btn-danger" onClick={()=>cancel()} style={{borderRadius:"15px",float:"right",marginRight:"5px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 
            {/* </div> */}
       </Layout></>

        
    )
}

export default SuperAdminRoleMaster;